import { useState } from "react";
import { Boxes } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import type { Account } from "../leads/types";

export function PasswordResetScreen({
  onComplete,
}: {
  onComplete: (account: Account) => void;
}) {
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError("");
    if (password !== confirmation) return setError("两次输入的密码不一致。");
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) return setError("重置链接缺少令牌，请重新申请。");
    setBusy(true);
    try {
      const result = await api<{ account: Account }>("/api/auth/reset", {
        method: "POST",
        body: JSON.stringify({ token, password }),
      });
      window.history.replaceState({}, "", "/");
      onComplete(result.account);
    } catch (reason) {
      setError(
        reason instanceof Error ? reason.message : "重置失败，请重新申请。",
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="grid min-h-dvh place-items-center bg-background p-4">
      <section className="w-full max-w-sm rounded-lg border bg-card p-6 sm:p-8">
        <div className="flex items-center gap-2.5 text-sm font-semibold">
          <Boxes className="size-[18px]" />
          货盘 Lite
        </div>
        <h1 className="mt-8 text-xl font-semibold">设置新密码</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          保存后直接进入工作区。
        </p>
        <form className="mt-6 space-y-4" onSubmit={submit}>
          <label className="block space-y-1.5 text-xs font-medium text-muted-foreground">
            新密码
            <Input
              type="password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="new-password"
              className="h-10"
            />
          </label>
          <label className="block space-y-1.5 text-xs font-medium text-muted-foreground">
            再次输入
            <Input
              type="password"
              required
              value={confirmation}
              onChange={(event) => setConfirmation(event.target.value)}
              autoComplete="new-password"
              className="h-10"
            />
          </label>
          {error && (
            <p
              role="alert"
              className="rounded bg-destructive/10 px-3 py-2 text-sm text-destructive"
            >
              {error}
            </p>
          )}
          <Button type="submit" className="h-10 w-full" disabled={busy}>
            {busy ? "保存中…" : "保存新密码并进入"}
          </Button>
        </form>
      </section>
    </main>
  );
}
